<template>
  <v-card>
    <v-card-title class="subtitle-1 pt-2 pb-0 d-flex justify-space-between">
      <span>{{ title }} </span>
      <slot name="controls"></slot>
    </v-card-title>
    <v-card-text :class="containerClasses">
      <slot>
       
      </slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    title: String,
    containerClasses: {
      type: Object,
      default: () => {
        return { "pa-2": true };
      },
    },
  },
};
</script>